import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { tenantApi, type Tenant } from "../api/tenantApi";

interface TenantCtx {
  tenant:  Tenant | null;
  loading: boolean;
  reload:  () => void;
}

const TenantContext = createContext<TenantCtx>({ tenant: null, loading: true, reload: () => {} });

export function TenantProvider({ children }: { children: ReactNode }) {
  const [tenant,  setTenant]  = useState<Tenant | null>(null);
  const [loading, setLoading] = useState(true);
  const [rev,     setRev]     = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    tenantApi.getMe()
      .then((t) => { if (active) setTenant(t); })
      .catch(() => { if (active) setTenant(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [rev]);

  return (
    <TenantContext.Provider value={{ tenant, loading, reload: () => setRev((r) => r + 1) }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() { return useContext(TenantContext); }
